<template>
    <div>
     <navbar :title="fad" :box="box"/>

        <van-tabs v-model="activeTabs" swipeable>
          <van-tab title="Anlık">
            <!-- <span style="position:absolute; top:28%;font-size:30px;left:30%;font-weight:bold; color:white; z-index:999999">{{parabirimi(total)}}</span>
              <div style="margin:30px auto;">
                <van-divider style="  position:relative">
                <van-circle  v-model="currentRate" :rate="100" :stroke-width="20" size="180px" :speed="40" :color="gradient"> 
                </van-circle>
                </van-divider>
              </div> -->
              <!-- <van-divider>Aktif Dönem Kazançları({{aay+' '+ayil}})</van-divider> -->
              <van-skeleton :loading="loading" title :row="3"/>
              <van-cell-group v-if="!loading">
              <van-divider>Birikmiş Kazanç</van-divider>

                <van-swipe-cell>
                    <template #left>
                    <van-button v-if="talepVarmi == 0 && total>0"  @click="odeme_talebi()"   square type="primary" text="Ödeme Talebi Gönder" />
                    <van-button v-else square type="danger" text="Bekleyen Ödeme Talebi var" />
                  </template>
                  <van-cell :border="false" title="Cüzdan Hesabınız" :value="parabirimi(total)" />
                </van-swipe-cell>

                <van-divider>Anlık Kazanç Tablonuz</van-divider>
                  <van-cell title="Liderlik Bonusu" :value="anlik.daralma" />
                  <van-cell title="Royallik" :value="anlik.qvpuani" />
                  <van-cell title="Royallik Bonusu" :value="anlik.qvbonus" />
                  <van-cell title="Toplam" :value="anlik.toplam"/>
              </van-cell-group>
              <van-notice-bar v-if="anlik.aktif === 0" text="Pasifsiniz, ay sonu kazanç elde etmek için aktiflik yapınız" left-icon="volume-o" />
          </van-tab>
          <van-tab title="Detay">
              <van-cell-group v-for="(item,index) in donemler" :key="index">
                  <van-button @click="aktifdonem(item.ay,item.yil)" type="info" size="large" block>{{aybul(item.ay)+' '+item.yil}} dönemini hesapla</van-button>
              </van-cell-group>
<!-- aşağıdaki butonları aslında sql den gelen sorgu ile when case yaparak yeni bir text oluşturabilirsin -->
          <van-panel v-for="(item,index) in cuzdan" :key="index" :title="aybul(item.ay)+' '+item.yil" :desc="parabirimi(kazanc(item.toplam,item.tip))" :status="durum(item.aktif)">
          </van-panel>

          </van-tab>
          <van-tab title="Harehet">
          <van-cell-group>
            <van-cell v-for="(item,index) in cuzdanHareket" :key="index" :title="item.tip" :value="parabirimi(item.tutar)" :label="trtgoster(item.tarih)" />
          </van-cell-group>

          </van-tab>          

        </van-tabs>
      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
//import { userService } from '@/plugins/_services';
import navbar from './nav'
import {Toast} from 'vant'

export default {
components:{
  navbar
},
  data() {
    return {
      currentRate:0,
      gradient:{
        '0%': '#3fecff',
        '100%': '#6149f6',
      },
      activeTabs:0,
      loading:false,
      show:false,
      active:'Cüzdan',
      cuzdan:[],
      donemler:[],
      anlik:{
        daralma:helper.funcs.parabirimi(0),
        qvpuani:helper.funcs.parabirimi(0),
        qvbonus:helper.funcs.parabirimi(0),
        toplam:helper.funcs.parabirimi(0)
      },
      kay:parseInt(helper.settings.ayar().ay),
      kyil:parseInt(helper.settings.ayar().yil),
      aay:helper.settings.donem().ay,
      ayil:parseInt(helper.settings.donem().yil),
      donemler:[],
      fad:"Cüzdan",
      ref_kod:helper.settings.ayar().referans,
      uye_kod:helper.settings.ayar().uye,
      uye_ad:helper.settings.ayar().uye_ad,
      parola:helper.settings.ayar().pass,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
      obje:[],
      obje2:[],
      derinlik:0,
      anakol:0,
      posts:[],
      tCuzdan:0,
      tip:0,
      cuzdanHareket:[],
      talepVarmi: 0
    };
  },
  computed: {
    total() {
      return this.cuzdanHareket.reduce(
        (acc, item) => acc + item.tutar,
        0
      );
    },    
  }, 
created (){
this.loading = true
this.odemetalebiVarmi()
this.aktifdonem(this.aay,this.ayil)
this.gecmis();
this.paysCuzdan(); // burada geçmişler çalışıyor
this.gercekCuzdan(); // burada kesintili cüzdan çalışıyor

},
methods:{
gercekCuzdan(){
  helper.request.get("gercekCuzdan/"+this.uye_kod)
  .then(res => { this.cuzdanHareket = res.results })
},
odemetalebiVarmi(){
  helper.request.get("odeme_talepleri/"+this.uye_kod)
  .then(res => {
    if (res.status) {
      this.talepVarmi = 1
    }
  })
},
paysCuzdan(){
  helper.request.get("paysCuzdan/"+this.uye_kod)
  .then(res => {
    this.tip = res.results[0].tip // üye tipini aldık
this.cuzdan = res.results.sort(function(a,b){return new Date(a.yil,a.ay, 1) - new Date(b.yil, b.ay, 1)}) 
// let toplam = 0
//   res.results.forEach(e => {
//     if (e.aktif === 1) {toplam+=e.toplam - e.odenen}
//     this.tCuzdan = toplam
//   });
  })
},
gecmis(){
  this.donemi( new Date(this.kyil, this.kay, 1),new Date(this.ayil, this.aay, 1))
  .then(res => {
    this.donemler = []
   res.forEach((element) => {
      helper.request.get("gecmis/"+element.ay+"/"+element.yil+'/'+this.uye_kod)
      .then(respo=> {
        if (respo.results.length === 0){
         // this.aktifdonem(element.ay,element.yil)

        this.donemler.push({ ay:element.ay, yil:element.yil})
        }
     })
   });
    

  })
  
},
aktifdonem(ay,yil){
  this.show=true
  this.obje = []
      helper.request.get("cuzdan/"+this.uye_kod+"/"+ay+"/"+yil)
      .then(res => {
        if (res.results.length === 0) this.show = false
         this.hobbala(res.results,ay,yil,0)
        })
},

    hobbala(arg,ay,yil,anakol){
      var pross = 0
      for (let i = 0, p = Promise.resolve(); i < arg.length; i++) {
        p = p.then(_ => new Promise(resolve => {
          
          //setTimeout(() => {
          anakol++
          this.derinlik = 1
          let data = {
          kod:arg[i].uye_kod,
          derinlik : this.derinlik,
          anakol:anakol,
          qv:arg[i].puan,
          ay:ay,
          yil:yil
          }
          //console.log(data)
          this.obje.push(data)
          //console.log(this.obje)
          this.kol(data.kod,data.derinlik,anakol,ay,yil)
            .then(res => {
              pross++
              if(arg.length === pross){
                setTimeout(() => {
                //console.log(this.obje)
                this.grupla(this.obje,ay,yil)
                  .then(response=> { 
                   //console.log(response.data)
                    this.havuz_kol_kontrol(response.data)
                     .then(resp => { 
                        this.show = false
                        // console.log( {
                        //     ay:ay,
                        //     yil:yil,
                        //     havuz:resp.havuz,
                        //     alan:resp.alan,
                        //     toplampv:resp.pv,
                        //     pvbolen:response.pv,
                        //     cvbolen:response.cv,
                        //     aktiflik:response.aktiflik
                        //   })                        
                        this.sonlandir(
                          {
                            ay:ay,
                            yil:yil,
                            havuz:resp.havuz,
                            alan:resp.alan,
                            toplampv:resp.pv,
                            pvbolen:response.pv,
                            cvbolen:response.cv,
                            aktiflik:response.aktiflik
                          }
                        )
                        .then(res=>{
                         if (res){
                           this.paysCuzdan()
                           this.gecmis()
                           }
                         else{
                           this.loading = false
                         }
                        })

                     })
                })
               }, 1000);
              }
              resolve()
            })
           }
        ))
      }
    },
    kol(kod,derinlik,anakol,ay,yil){
      return new Promise ((resolve,reject)=>{
        helper.request.get("cuzdan/"+kod+"/"+ay+"/"+yil)
        .then(res => {
          if (res.results.length===0){resolve(true)}
           else{
             derinlik++
              this.getProduct(res.results,derinlik,anakol,ay,yil)
               .then(res=>{
                 this.getProduct2().then(response => {
                   //setTimeout(() => {
                     resolve()
                   //},1000 );
                   
                 })
             })
            }
        })
      })
    },
    getProduct2(){
      return new Promise ((resolve,reject)=>{
        var pros = 0
        this.obje2.forEach((element) => { 
            this.kol(element.kod,element.derinlik,element.anakol,element.ay,element.yil)
            pros++
        });
        if (pros === this.obje2.length) resolve()
      })
    },
    getProduct(arg,derinlik,anakol,ay,yil){ // sabit arttıcı
    return new Promise ((resolve,reject)=>{
    this.obje2 = []
      var pros = 0
          arg.forEach((element,i) => {
              let data = {
                 kod:element.uye_kod,
                 derinlik : derinlik,
                 anakol:anakol,
                 qv:element.puan,
                 ay:ay,
                 yil:yil
               }
          this.obje.push(data)
          this.obje2.push(data)
          pros++
          });

        //  },500);
          if(arg.length === pros){
            resolve(true)
          }
      })
    },
    grupla(arr,ay,yil){
        var cnt = 0
        return new Promise ((resolve,reject) => {
          helper.request.get("derinlik/"+ay+"/"+yil)
          .then(res => {
            var result = [] 
            arr.forEach(function (a) {
              cnt++
              if ( !this[a.anakol] ) {
                  this[a.anakol] = { anakol: a.anakol,kod:a.kod,qv:0,pv:0};
                    result.push(this[a.anakol]);
              }
              this[a.anakol].qv +=a.qv;
              if (a.derinlik<=res.pvd)
              {
                this[a.anakol].pv +=(res[a.derinlik] * a.qv)/100;
              }
              if (arr.length === cnt) {
                resolve({data:result,cv:res.cv,qv:res.qv,pv:res.pv,aktiflik:res.aktiflik})
              }
            }, Object.create(null));
            // setTimeout(() => {
              
            // }, 2000);
            
            })
        }) 
    },
    havuz_kol_kontrol(obj){
      return new Promise((resolve,reject) => {

        let pross = 0
        let toplamkol = obj.length
        let toplampv = 0

        let dort_k6 = 0 // 400000
        let dort_k5 = 0 // 250000
        let dort_k4 = 0 // 130000
        let dort_k3 = 0 // 90000
        let dort_k2 = 0 // 50000
        let dort_k1 = 0 // 20000
        let uc_k2 = 0 // 10000
        let uc_k1 = 0 // 25000
        let iki_k4 = 0 // 4000
        let iki_k3 = 0 // 2500
        let iki_k2 = 0 // 1000
        let iki_k1 = 0 // 100
        obj.forEach(arg => {
         toplampv += arg.pv
            if (arg.qv>=100) iki_k1++ //havuz 1 lik
            if (arg.qv>=1000) iki_k2++ //havuz 3 lük
            if (arg.qv>=2500) iki_k3++ //havuz 3 lük
            if (arg.qv>=4000) iki_k4++ //havuz 3 lük
            // ikilik sistem
            if (arg.qv>=10000)  uc_k1++ //havuz 5 lik
            if (arg.qv>=25000)  uc_k2++ //havuz 5 lik
            //üçlük sistem bitiş

            if (arg.qv>=20000 )  dort_k1++ //havuz 6 lık
            if (arg.qv>=50000) dort_k2++ //havuz 6 lık
            if (arg.qv>=90000)  dort_k3++ //havuz 6 lık
            if (arg.qv>=130000) dort_k4++ //havuz 6 lık
            if (arg.qv>=250000)  dort_k5++ //havuz 6 lık
            if (arg.qv>=400000) dort_k6++ //havuz 6 lık
          pross++
        });

        if(pross = toplamkol){
            if(dort_k6 >= 4) {resolve({havuz:6,alan:'dort_k6',pv:toplampv})} //dört_k6
              else if(dort_k5 >= 4) {resolve({havuz:6,alan:'dort_k5',pv:toplampv})} //dört_k5
                else if(dort_k4 >= 4) {resolve({havuz:6,alan:'dort_k4',pv:toplampv})} //dört_k4
                  else if(dort_k3 >= 4) {resolve({havuz:6,alan:'dort_k3',pv:toplampv})} //dört_k3
                    else if(dort_k2 >= 4) {resolve({havuz:6,alan:'dort_k2',pv:toplampv})} //dört_k2
                      else if(dort_k1 >= 4) {resolve({havuz:6,alan:'dort_k1',pv:toplampv})} //dört_k1
                        else if(uc_k2 >= 3) {resolve({havuz:5,alan:'uc_k2',pv:toplampv})}// üç_k2
                          else if(uc_k1 >= 3) {resolve({havuz:5,alan:'uc_k1',pv:toplampv})}// üç_k1
                            else if(iki_k4 >= 2) {resolve({havuz:3,alan:'iki_k4',pv:toplampv})}// iki_k4
                              else if(iki_k3 >= 2) {resolve({havuz:3,alan:'iki_k3',pv:toplampv})}// iki_k3
                                else if(iki_k2 >= 2) {resolve({havuz:3,alan:'iki_k2',pv:toplampv})}// iki_k2
                                  else if(iki_k1 >= 2) {resolve({havuz:1,alan:'iki_1',pv:toplampv})}// iki_1
            else{
                {resolve({havuz:1,alan:'yok',pv:toplampv})} // olmayan bir alanı gönderiyoruz 
            }
        }
      })

   },


donemi(d1, d2) {
  let result =[]
  return new Promise ((resolve,reject) => {
    let yili = this.kyil
    let ayi = this.kay
    var i
    let pros = 0
    var diff = this.monthDiff(d1, d2);
    for (i = 0; i < diff; i++) {
       if (ayi > 12) {
         yili++
         ayi = 1
       }
      result.push({
        yil:yili,
        ay:ayi++
      })
     pros++
    }
    if (pros === diff) {resolve(result)}
  })
   // console.log(
        // d1.toISOString().substring(0, 10),
        // "to",
        // d2.toISOString().substring(0, 10),
        // ":",
        //diff
   // );
},
monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
},
sonlandir(obj){
  let qvpuan = 0
  let qvbonus = 0
   return new Promise((resolve,reject) => {
  //console.log(obj)
  let aktiflik = 0
  helper.request.get("aktifmi/"+this.uye_kod+"/"+obj.ay+"/"+obj.yil)
  .then(res=>{
    if (res.puan>= obj.aktiflik) aktiflik = 1
    helper.request.get("havuz/"+obj.ay+"/"+obj.yil+"/"+obj.havuz+"/"+obj.alan)
    .then(respo=> {
    //  console.log(respo)
    //  console.log(obj)
     if (respo.kisi===0){
       qvpuan = 0
       qvbonus = 0
      }
      else{
        qvpuan = ((respo.tcv *((respo.anaoran/100)/respo.kisi))/obj.cvbolen)
        qvbonus = (respo.tcv * (respo[obj.alan]/100)/respo.kisi) / obj.cvbolen
      }

      let objecti = {
       uye_kod:this.uye_kod,
       ay:obj.ay,
       yil:obj.yil,
       daralma:obj.toplampv * obj.pvbolen,
       qvpuani:qvpuan,
       qvbonus:qvbonus,
       aktif:aktiflik
      }
      if(obj.ay === this.aay && obj.yil === this.ayil){
        this.anlik.daralma = helper.funcs.parabirimi(objecti.daralma)
        this.anlik.qvpuani = helper.funcs.parabirimi(objecti.qvpuani)
        this.anlik.qvbonus =helper.funcs.parabirimi(objecti.qvbonus)
        this.anlik.toplam = helper.funcs.parabirimi(objecti.daralma+objecti.qvpuani+objecti.qvbonus)
        this.anlik.aktif = objecti.aktif
        resolve(false)
      }
       else{
         let newData = {
            uye_kod: this.uye_kod,
            toplam:(objecti.daralma + objecti.qvpuani + objecti.qvbonus),
            ay: obj.ay,
            yil: obj.yil,
            aktif: objecti.aktif,
            odendi: 0,
            talep: 0,
            odenen: 0,
         }
         helper.request.post("gecmis",newData)
         .then(restir=>{
           if (newData.aktif == 1 ) {
            this.odemeEkle(newData.uye_kod,this.tip,newData.toplam)
           }
             resolve(true)

         })
       }
       })
})
   })

},
odemeEkle(kod,tip,toplam){
  let newData = {
    uye_kod : kod,
    tutar:this.kazanc(toplam,tip),
    tip:'Kazanç'
  }
  helper.request.post("odemeEkle",newData)

},
aybul(res){
  switch(res) {
  case 1:
    return "Ocak"
    break;
  case 2:
    return "Şubat"
    break;  case 3:
    return "Mart"
    break;  case 4:
    return "Nisan"
    break;  case 5:
    return "Mayıs"
    break;  case 6:
    return "Haziran"
    break;  case 7:
    return "Temmuz"
    break;  case 8:
    return "Ağustos"
    break;  case 9:
    return "Eylül"
    break;  case 10:
    return "Ekim"
    break;  case 11:
    return "Kasım"
      case 12:
    return "Aralık"
    break;
    break;
}
},
      parabirimi(res){
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
      },
      odenemez(donem){
        Toast(donem + " döneminde pasif olduğunuz hesaba yatırılamaz")
      },
      odeme_talebi(){
        this.show = true
        let toplam = 0
        let cnt =0
        this.cuzdanHareket.forEach(e => {
          cnt++
          toplam = toplam+e.tutar
          if (this.cuzdanHareket.length === cnt) {
            helper.request.post('odeme_talebi/',{uye_kod:this.uye_kod,toplam:toplam})
            .then(res =>{
              Toast("Ödeme Talebiniz Alındı")
              this.talepVarmi = 1
              this.show = false
            })
          }
        });

      },
      durum(durum){
        if (durum == 1) {return 'Cüzdana Aktarıldı'}
        else return 'Pasifsiniz'
      },
      kazanc(toplam,tip){
        if (tip == 0) { return toplam - (toplam * (20 / 100)) }
        else{ return toplam + (toplam * (8 / 100))}
      },
          trtgoster(uzuntarih){
      const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
      const d = new Date(uzuntarih);
      return d.getDate() +'-'+ monthNames[d.getMonth()]+'-'+d.getFullYear();
    },

}
};
</script>



// WEBPACK FOOTER //
// src/components/cuzdan.vue